<div class="message-dialog-container">
  <div class="header">
    <div class="header-content">
      <span class="title">Envoyer un message à l'agence</span>
      <div class="mission-badge" *ngIf="data.missionTitle">
        <mat-icon class="mission-icon">assignment</mat-icon>
        <span class="mission-text">{{ data.missionTitle }}</span>
      </div>
    </div>
    <button class="close-btn" (click)="close()" mat-icon-button aria-label="Fermer">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    <!-- Recording Indicator -->
    <div class="recording-indicator" *ngIf="isRecording">
      <div class="recording-pulse"></div>
      <span class="recording-text">Enregistrement en cours...</span>
      <span class="recording-time">{{ recordingDuration }}s</span>
    </div>

    <div class="message-input-wrapper" *ngIf="!isRecording">
      <textarea [(ngModel)]="messageText" [maxlength]="maxLength"
        placeholder="Écrivez votre message concernant cette mission..." rows="5" [disabled]="isSending"
        class="message-textarea"></textarea>
      <div class="char-counter" [class.warning]="remainingChars < 50">
        {{ remainingChars }} caractères restants
      </div>
    </div>

    <!-- Success Message -->
    <div class="alert alert-success" *ngIf="showSuccess">
      <mat-icon>check_circle</mat-icon>
      <span>Message envoyé avec succès !</span>
    </div>

    <!-- Error Message -->
    <div class="alert alert-error" *ngIf="showError">
      <mat-icon>error</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>
  </div>

  <div class="footer">
    <!-- Left side: Attachments -->
    <div class="attachment-controls">
      <!-- Hidden file input -->
      <input type="file" #fileInput (change)="onFileSelected($event)"
        accept="image/png,image/jpeg,image/jpg,application/pdf,video/mp4,video/webm,video/ogg" style="display: none;">

      <!-- Attachment button -->
      <button mat-icon-button class="action-btn" (click)="triggerFileInput()" title="Joindre un fichier"
        [disabled]="isSending || isRecording" *ngIf="!messageText.trim()">
        <mat-icon>attach_file</mat-icon>
      </button>

      <!-- Voice recording button -->
      <button mat-icon-button class="action-btn voice-btn" [class.recording]="isRecording"
        (click)="isRecording ? stopRecording() : startRecording()"
        [title]="isRecording ? 'Arrêter l\'enregistrement' : 'Enregistrer un message vocal'" [disabled]="isSending"
        *ngIf="!messageText.trim()">
        <mat-icon>{{ isRecording ? 'stop' : 'mic' }}</mat-icon>
      </button>
    </div>

    <!-- Right side: Actions -->
    <div class="action-controls">
      <button mat-button color="warn" (click)="close()" [disabled]="isSending || isRecording">
        Annuler
      </button>
      <button mat-raised-button color="primary" (click)="sendMessage()"
        [disabled]="!messageText.trim() || isSending || isRecording" class="send-btn" *ngIf="!isRecording">
        <mat-icon *ngIf="!isSending">send</mat-icon>
        <mat-spinner *ngIf="isSending" diameter="20"></mat-spinner>
        <span>{{ isSending ? 'Envoi...' : 'Envoyer' }}</span>
      </button>
    </div>
  </div>
</div>